import { ContentContainer } from '@/components/ui/content-container';
import { MasonryGrid } from '@/components/ui/masonry-grid';
import { Heading2 } from '@/components/ui/typography';
import { cn } from '@/lib/utils';
import type { ReviewWidgetProps } from '../definition';
import {
  REVIEW_ALIGN_ITEMS_CLASS,
  type ReviewDisplaySettings,
  resolveReviewSegments,
  resolveReviewSizeClass,
  reviewCardStyle,
} from './review-display';
import { REVIEW_CARD_PADDING_CLASS, ReviewAttribution, ReviewQuote, ReviewStars } from './shared';

export function GridVariant({
  title,
  reviews,
  settings,
}: ReviewWidgetProps & { settings?: ReviewDisplaySettings }) {
  if (reviews.length === 0) return null;

  const { showIcon, showName, segments } = resolveReviewSegments(settings, 'grid');
  const paddingClass = resolveReviewSizeClass(settings?.padding, REVIEW_CARD_PADDING_CLASS, 'md');
  const alignClass = settings?.align ? REVIEW_ALIGN_ITEMS_CLASS[settings.align] : '';
  const cardStyle = reviewCardStyle(settings);

  return (
    <section>
      <ContentContainer as="div">
        {title ? <Heading2 className="mb-8 text-center">{title}</Heading2> : null}

        <MasonryGrid columns={2} gap={settings?.gap}>
          {reviews.map((review, index) => {
            const key = review.id || `review-${index}`;

            return (
              <article
                key={key}
                className={cn(
                  'flex flex-col rounded-md border border-slate-200 bg-white',
                  paddingClass,
                  alignClass,
                )}
                style={cardStyle}
              >
                {segments.map((segment) => {
                  if (segment === 'rating') {
                    return <ReviewStars key="rating" review={review} className="mt-2 first:mt-0" />;
                  }
                  if (segment === 'review') {
                    return <ReviewQuote key="review" review={review} className="mt-2 first:mt-0" />;
                  }
                  return (
                    <ReviewAttribution
                      key="attribution"
                      review={review}
                      compact
                      showIcon={showIcon}
                      showName={showName}
                      className="mt-2 first:mt-0"
                    />
                  );
                })}
              </article>
            );
          })}
        </MasonryGrid>
      </ContentContainer>
    </section>
  );
}
